module.exports = __webpack_public_path__ + "static/media/dinside.2b145277.png";